import { render } from "./AIRecipeCard.vue?vue&type=template&id=a28e8bfa&scoped=true"
import script from "./AIRecipeCard.vue?vue&type=script&lang=js"
export * from "./AIRecipeCard.vue?vue&type=script&lang=js"

import "./AIrecipeCard.css?vue&type=style&index=0&id=a28e8bfa&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28e8bfa"]])

export default __exports__